import Axios from "./axios";

const resource = "shop-checkout-sliders";

export default {
  get() {
		return Axios.get(`${resource}`);
	}
}